import { render, staticRenderFns } from "./MyAnnouncements.vue?vue&type=template&id=fe6bab70"
import script from "./MyAnnouncements.vue?vue&type=script&lang=js"
export * from "./MyAnnouncements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fe6bab70')) {
      api.createRecord('fe6bab70', component.options)
    } else {
      api.reload('fe6bab70', component.options)
    }
    module.hot.accept("./MyAnnouncements.vue?vue&type=template&id=fe6bab70", function () {
      api.rerender('fe6bab70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/pages/notification/MyAnnouncements.vue"
export default component.exports